import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import createbuild from "../assets/img/community/check-circle.svg";
import succ from "../assets/img/community/success-filled.svg";

const ResponsePopup = (props) => {

  return (

    <div >
      <Modal show={props.isSucess} onHide={props.CancelPopup} backdrop="static" keyboard={false} dialogClassName="small-custom-modal modal-dialog-centered">

        <Modal.Body>
          <div className="altr-icon">
            <img src={createbuild} className="succ-icon"></img>

          </div>



          <div className="succ-content"  ><p className="text-center" style={{ fontSize: "14px" }}>
            {props.message}</p></div>

        </Modal.Body>
        <Modal.Footer className="full-w" >

          <button className="next-btn" onClick={props.CancelPopup}>
            OK
          </button>
        </Modal.Footer>

      </Modal>
    </div>
  );

};
export default ResponsePopup;
